<template>
  <div>
    <b-collapse :open.sync="isOpen">
      <template #trigger>
	<div v-if="!isOpen" class="has-text-right">
	  <a>{{$t('Search options')}}</a>
	</div>
      </template>
      <b-notification :active.sync="isOpen">
	<slot></slot>
      </b-notification>
    </b-collapse>
  </div>
</template>

<script>
 export default {
   data: () => ({ isOpen: true })
 }
</script>
